import "./styles/index.scss";

import { render } from "preact";

// import { configure } from "mobx";
import { EventBus } from "./lib/events";

import "../packages/lang/Languages.patch";

import { App } from "./pages/app";

import "./updateWorker";

EventBus.init();

if (import.meta.env.DEV) {
    // Закомментил это по той причине что много варнингов у нас слишком много проблем с мобксом
    // Настраиваем mobx построже, потому что с ним проблемы бывают
    // configure({
    //   enforceActions: "always",
    //   computedRequiresReaction: true,
    //   reactionRequiresObservable: true,
    //   observableRequiresReaction: true,
    //   disableErrorBoundaries: true
    // });
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
render(<App />, document.getElementById("app")!);
